import { Environment } from './environment.interface';
import packageJson from '../../package.json'

export const environment: Environment = {
    version: packageJson.version,
    environment: 'development',
    baseUrl: 'https://dev.videolectures.net',
    matomoUrl: 'https://dev.matomo.videolectures.net/',
    apiUrl: 'https://dev.backend.videolectures.net/api'
};
